import { z } from 'zod';

export const EstadosLicitacionesResponseSchema = z.object({
  description: z.string(),
  status_code: z.number(),
  data: z.record(z.number())
});

export type EstadosLicitacionesResponse = z.infer<typeof EstadosLicitacionesResponseSchema>;

export const ActualizarEstadoRequestSchema = z.object({
  listado: z.array(z.object({
    codigo: z.string(),
    nuevo_estado: z.number()
  })),
  tematica_id: z.number()
});

export type ActualizarEstadoRequest = z.infer<typeof ActualizarEstadoRequestSchema>; 